import React from "react";
import { Link } from "react-router-dom";

import { Card, CardContent, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { accountNameRenderer } from "../../../components/common/AccountNameRenderer";

import { isAuthorized } from "../../../utils/appUtils";
import { AclType } from "../../../utils/constants";

const useAsideStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up("sm")]: {
      width: "18em",
      minWidth: "18em",
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(0.5),
      overflow: "initial",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));

export const WorkAside = ({
  backPath,
  inbound,
  inventory,
  inventoryItems = [],
  ...props
}) => {
  const classes = useAsideStyles();
  const account = inventory?.account || inbound?.account;
  const accountId = inventory?.accountId || inbound?.accountId;
  const accountRecord = account || {
    accountName: inventory?.accountName || inbound?.accountName,
    businessName: inventory?.accountName || inbound?.accountName,
    displayName: inventory?.accountName || inbound?.accountName,
  };
  const inboundShipmentId = inventory?.inboundShipmentId || inbound?.id;
  const inventoryId = inventory?.id;
  const productId = inventory?.productId || inventory?.product?.id;
  const productName = inventory?.productName || inventory?.product?.name;
  const inventoryItemList =
    inventoryItems.length > 0
      ? inventoryItems
      : inventory?.inventoryItems?.items || [];
  const linkBackPath = backPath
    ? [...backPath, props.location.pathname]
    : [props.location.pathname];

  if (!inventory && !inbound && inventoryItemList.length === 0) return null;

  return (
    <Card className={classes.root}>
      <CardContent>
        <Grid container direction="column" spacing={1}>
          {accountId && (
            <Grid item xs={12}>
              <Typography variant="overline" color="textSecondary">
                Account:
              </Typography>
              <br />
              <Link
                to={{
                  pathname: `/accounts/${accountId}${isAuthorized(AclType.ACCOUNTS) ? "" : "/show"}`,
                  state: { backPath: linkBackPath },
                }}
              >
                <Typography variant="body2" color="primary">
                  {accountNameRenderer(accountRecord)}
                </Typography>
              </Link>
            </Grid>
          )}
          {inboundShipmentId && (
            <Grid item xs={12}>
              <Typography variant="overline" color="textSecondary">
                Inbound Shipment:
              </Typography>
              <br />
              <Link
                to={{
                  pathname: `/inboundShipments/${inboundShipmentId}`,
                  state: { backPath: linkBackPath },
                }}
              >
                <Typography variant="body2" color="primary">
                  {inbound?.poNumber || inventory?.poNumber || inboundShipmentId}
                </Typography>
              </Link>
            </Grid>
          )}
          {inventoryId && (
            <Grid item xs={12}>
              <Typography variant="overline" color="textSecondary">
                Inventory:
              </Typography>
              <br />
              <Link
                to={{
                  pathname: `/inventories/${inventoryId}`,
                  state: { backPath: linkBackPath },
                }}
              >
                <Typography variant="body2" color="primary">
                  {inventory?.productName || inventoryId}
                </Typography>
              </Link>
              {productId && (
                <>
                  <Typography variant="overline" color="textSecondary">
                    Product:
                  </Typography>
                  <br />
                  <Link
                    to={{
                      pathname: `/products/${productId}`,
                      state: {
                        account,
                        backPath: linkBackPath,
                      },
                    }}
                  >
                    <Typography variant="body2" color="primary">
                      {productName || productId}
                    </Typography>
                  </Link>
                </>
              )}
            </Grid>
          )}
          {inventoryItemList.length > 0 && (
            <Grid item xs={12}>
              <Typography variant="overline" color="textSecondary">
                Inventory Items:
              </Typography>
              <br />
              {inventoryItemList.map((item) => (
                <Link
                  key={item.id}
                  to={{
                    pathname: `/inventoryItems/${item.id}`,
                    state: {
                      backPath: linkBackPath,
                      inventory,
                    },
                  }}
                >
                  <Typography variant="body2" color="primary">
                    {item.locationFullName || item.id}
                  </Typography>
                </Link>
              ))}
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};
